<style lang="css">
@import '../css/bootstrap.css';
@import '../css/bootstrap-vue.css';
@import '../css/admin-table.css';
</style>
<style lang="scss" scoped>
@import '../css/admin.scss';
</style>
<template>
  <div class="admin-page">
    <admin-header :tit="this.title"></admin-header>
    <admin-side></admin-side>
    <section class="admin-template">
      <h2 class="sub-tit">매물 관리</h2>
      <div class="contents">
        <b-container fluid>
          <!-- User Interface controls -->
            <b-row>
             <b-col class="my-1 text-left type-box">
               <b-form-group
                label="매물 Type"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" id="form-select" v-model="typeSelected" :options="itemOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="my-1 text-left type-box">
               <b-form-group
                label="거래 Type"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" v-model="dealSelected" :options="dealOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="my-1 text-left type-box select-box">
               <b-form-select size="sm" class="item-select" id="form-address-first" v-model="addressCitySelected" :options="addressCity"></b-form-select>
            </b-col>
            <b-col class="my-1 text-left type-box select-box">
               <b-form-select size="sm" class="item-select" id="form-address-second" v-model="addressCountySelected" :options="addressCounty"></b-form-select>
            </b-col>
            <b-col class="my-1 filter-box estate-search-area">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    type="search"
                    placeholder="주소 및 주소에 관한 KeyWord로 검색해주세요."
                    v-model="searchText"
                  ></b-form-input>
                  <b-button size="sm" @click="itemFilter(true)" class="search-btn">검색</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            id="expert-management"
            :items="items"
            :fields="fields"
            stacked="md"
            show-empty
            small
          >
            <template #cell(idEstate)="row">
              {{ row.value }}
            </template>
            <template #cell(typeEstateNm)="row">
              {{ row.value }}
            </template>
            <template #cell(typeDealNm)="row">
              {{ row.value }}
            </template>
            <template #cell(priceEstate)="row">
              {{ row.value | numberToKor }}
            </template>
            <template #cell(depositEstate)="row">
              {{ row.value | numberToKor }}
            </template>
            <template #cell(addrEstate)="row">
              {{ row.value | truncate(50, '...') }}
            </template>
            <template #cell(actions)="row">
              <b-button size="sm" @click="modifyItem(row.item, row.index)" class="save-btn mr-1">수정</b-button>
              <b-button size="sm" @click="deleteItem(row.item, row.index)" class="deleat-btn">삭제</b-button>
            </template>
          </b-table>
          <b-row>
            <b-col lg="12" class="my-1 text-center">
              <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              aria-controls="expert-management"
             @change="pageChangeEvent"
            ></b-pagination>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" class="my-1 text-right">
              <b-button v-b-modal.modal-scrollable variant="primary" @click="newItem()">신규</b-button>
            </b-col>
          </b-row>
        </b-container>
        <b-modal id="modal-scrollable" size="xl" ok-title="취소" ok-only>
          <AdminRegEstate></AdminRegEstate>
        </b-modal>
      </div>
    </section>
  </div>
</template>
<script>
import AdminHeader from '@/components/AdminHeader'
import AdminSide from '@/components/AdminSide'
import AdminRegEstate from '@/admin/AdminRegEstate'
import { mapGetters } from 'vuex'

export default {
  name: 'AdminEstate',
  components: {
    'admin-header': AdminHeader,
    'admin-side': AdminSide,
    AdminRegEstate
  },
  data () {
    return {
      title: '관리자 페이지',
      layerPopPost: false,
      dealSelected: '',
      typeSelected: '',
      itemOptions: [
        /* { value: '0', text: 'Type1' },
        { value: '1', text: 'Type2' } */
      ],
      dealOptions: [
        { value: '', text: '전체' }
      ],
      addressCitySelected: '',
      addressCountySelected: '',
      searchText: '',
      addressCity: [
        { value: '', text: '시도 선택' }
      ],
      addressCounty: [
        { value: '', text: '구군 선택' }
      ],
      /* items: [
        { status: 'Type1', number: '1', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: 'Type1', number: '2', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: 'Type1', number: '3', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: 'Type1', number: '4', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: 'Type1', number: '5', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: 'Type1', number: '6', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' },
        { status: 'Type2', number: '7', tit: '빈손으로 왔다 빈손으로 간다는 뜻. 인생의 무상과 허무를 나타내는 말로서, 사람이 이 세상에 태어날 때 아무것도 손에 들고 온 것이 없이 빈손으로 태어나는 것처럼,', date: '2020.03.08' }
      ], */
      // items: [],
      fields: [
        { key: 'idEstate', label: '매물 번호', class: 'text-center' },
        { key: 'typeEstateNm', label: '매물 Type', class: 'text-center' },
        { key: 'typeDealNm', label: '거래 Type', class: 'text-center' },
        { key: 'priceEstate', label: '가격', class: 'text-center' },
        { key: 'depositEstate', label: '보증금', class: 'text-center' },
        { key: 'addrEstate', label: '주소', class: 'text-center' },
        { key: 'actions', label: '', class: 'text-center' }
      ],
      estateId: '',
      perPage: 10, // item length
      // totalRows: 1,
      currentPage: 1,
      fileRecords: []
    }
  },
  created () {
    this.initEstateCode()
  },
  watch: {
    totalArea () {
      this.setSidoSetting()
    },
    addressCitySelected () {
      this.setGunguSetting()
    },
    typeEstate () {
      this.itemOptions = []
      for (var i = 0; i < this.typeEstate.length; i++) {
        let tmp = { value: this.typeEstate[i].deCode, text: this.typeEstate[i].codeNm }
        this.itemOptions.push(tmp)
      }
      if (this.typeSelected === '') {
        this.typeSelected = this.typeEstate[0].deCode
      }
      // this.typeSelectNm = this.typeEstate[0].codeNm
      /* console.log('filter = ')
      this.itemFilter(true) */
    },
    dealEstate () {
      this.dealOptions = [
        { value: '', text: '전체' }
      ]
      for (var i = 0; i < this.dealEstate.length; i++) {
        let tmp = { value: this.dealEstate[i].deCode, text: this.dealEstate[i].codeNm }
        this.dealOptions.push(tmp)
      }
    }
  },
  methods: {
    estateSave () {
      this.$nextTick(() => {
        alert('저장이 완료 되었습니다.')
        this.itemFilter(false)
        this.$bvModal.hide('modal-scrollable')
      })
    },
    pageChangeEvent (page) {
      this.currentPage = page
      this.itemFilter(false)
    },
    initEstateCode () {
      // console.log(this)
      // console.log('=========================')
      this.$store.dispatch('apiEtcCodelists', {'Code': '001', 'DeCode': ''})
      this.$store.dispatch('apiEtcCodelists', {'Code': '002', 'DeCode': ''})
      // expertmanagement.js에 내장 됨
      this.$store.dispatch('apiTotalArea')
    },
    itemFilter (flag) {
      /* var flag = this.searchValidation()
      if (flag) {
        const param = {
          'typeEstate': this.typeSelected,
          'typeDeal': this.dealSelected,
          'region1': this.addressCitySelected,
          'region2': this.addressCountySelected,
          'keywoerd': this.searchText,
          'currnetPage': this.currentPage
        }
        this.$store.dispatch('apiAdminEstateList', param)
      } */
      // var flag = this.searchValidation()
      let param = ''
      if (flag) {
        this.currentPage = 1
        // reset을 해야 할 경우 true
      }
      param = {
        'typeEstate': this.typeSelected,
        'typeDeal': this.dealSelected,
        'region1': this.addressCitySelected,
        'region2': this.addressCountySelected,
        'keywoerd': this.searchText,
        'currnetPage': this.currentPage,
        'prePage': this.perPage
      }
      this.$store.dispatch('apiAdminEstateList', param)
    },
    searchValidation () {
      if (this.addressCitySelected === '') {
        alert('시군구를 입력해주세요.')
        return false
      } else if (this.addressCountySelected === '') {
        alert('읍면동을 입력해주세요.')
        return false
      }
      return true
    },
    modifyItem (item, index) {
      // alert('수정')
      this.estateId = item.idEstate
      // console.log('this.estateId = ' + this.estateId)
      this.$root.$emit('bv::show::modal', 'modal-scrollable')
    },
    deleteItem (item, index) {
      // alert('삭제')
      // estateId
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        // 삭제 로직
        // console.log('item.estateId = ' + item.idEstate)
        this.$store.dispatch('apiAttachedFiles', {'Gubun': '01', 'idAtFile': item.idEstate, 'flag': 'SELECT'}).then((res) => {
          this.fileRecords = []
          for (let i = 0; i < this.fileInfo.length; i++) {
            // console.log('this.fileInfo = ' + JSON.stringify(this.fileInfo[i]))
            const info = this.getFileInfo(this.fileInfo[i])
            this.fileRecords.push(info)
          }
          // console.log('fileRecords = ' + this.fileRecords)
          this.callDeleteEstate(item.idEstate)
        }).catch(() => {
          alert('세션 만료 또는 잘못된 접근 입니다.')
        })
      }
    },
    callDeleteEstate (id) {
      this.$store.dispatch('apiAdminDeleteEstate', {'estateId': id, 'idAtFile': id, 'Gubun': '01'}).then(() => {
        // console.log('this.estateDelRtn = ' + this.estateDelRtn)
        this.itemFilter(false)
        this.deleteFiles(id)
      })
    },
    deleteFiles (id) {
      if (this.fileRecords.length > 0) {
        const params = {
          'deleteFiles': this.fileRecords,
          'gubun': '01',
          'idDtFile': id
        }
        this.$store.dispatch('apiDeleteFiles', params)
      }
    },
    newItem () {
      // alert('신규')
      this.estateId = ''
      this.$root.$emit('bv::show::modal', 'modal-scrollable')
    },
    getFileInfo (item) {
      if (item.nameAtFile === '') {
        return ''
      } else {
        let file = {
          name: item.nameAtFile,
          file: { name: item.nameAtFile },
          url: item.path,
          type: item.fileType,
          ext: item.fileExt
        }
        return file
      }
    },
    setSidoSetting: function () {
      var tmpArr = []
      this.addressCity = [
        { value: '', text: '시도 선택' }
      ]
      for (var i = 0; i < this.totalArea.length; i++) {
        if (tmpArr.indexOf(this.totalArea[i].sido) === -1) {
          tmpArr.push(this.totalArea[i].sido)
          var tmp = { value: this.totalArea[i].sido, text: this.totalArea[i].sido }
          this.addressCity.push(tmp)
        }
        // console.log(this.totalArea[i].sido)
      }
      this.itemFilter(true)
    },
    setGunguSetting: function () {
      this.addressCounty = [
        { value: '', text: '구군 선택' }
      ]
      this.addressCountySelected = ''
      if (this.addressCitySelected !== '') {
        for (let i = 0; i < this.totalArea.length; i++) {
          if (this.totalArea[i].sido === this.addressCitySelected) {
            const tmp = {value: this.totalArea[i].gugun, text: this.totalArea[i].gugun}
            this.addressCounty.push(tmp)
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      typeEstate: 'getEtcCode001List',
      dealEstate: 'getEtcCode002List',
      totalArea: 'getTotalArea',
      items: 'getAdminEstate',
      totalRows: 'getAdminTotalCount',
      fileInfo: 'getAttachedFile',
      estateDelRtn: 'getAdminDelRtn'
    })
    /* ,
    totalRows () {
      return this.items.length
    } */
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/AdminEstate.vue